<template>
	<page>
		<module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                  <c-form-item type="input" label="商品名称" name="product_name"></c-form-item>
                  <c-form-item v-if="systemConfig.product_number_required == 'ON'" type="input" label="商品货号" name="product_itemnumber" placeholder="精确匹配"></c-form-item>
                  <c-form-item type="checkbox" label="商品状态" name="state" :options="productState"></c-form-item>
                  <c-form-item v-if="systemConfig.share_enable == 'ON'" type="select" label="销售模式" name="sales_model" :options="searchSalesModelOptions"></c-form-item>
                  <c-form-item v-if="systemConfig.share_enable == 'ON'" type="checkbox" label="可售范围" name="visible_user_level" :options="userLevelOptions"></c-form-item>
                </c-form>
            </m-search>
            <m-operate>
                <c-button power="b_share_award_edit" color="sys" @click="batchSetProductShareAward()">添加分享赚商品</c-button>
                <c-button power="b_share_award_edit" color="black" @click="otherConfig()">设置可分享会员</c-button>
            </m-operate>
            <c-table ref="table">
                <c-table-column
                        label="商品状态"
                        name="state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 0" style="color:red">{{productStateName[data.state]}}</span>
                        <span v-if="data.state == 1" style="color:#999999">{{productStateName[data.state]}}</span>
                        <span v-if="data.state == 2" style="color:green">{{productStateName[data.state]}}</span>
                        <span v-if="data.state == 3" style="color:blue">{{productStateName[data.state]}}</span>
                        <span v-if="data.state == 4" style="color:red">{{productStateName[data.state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="商品信息"
                        width="300"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                    </template>
                </c-table-column>

                <c-table-column
                    label="销售模式"
                    width="75"
                    name="sales_model"
                    v-if="systemConfig.share_enable == 'ON'"
                >
                  <template #default="{data}">
                    <span v-if="data.sales_model == 1" style="color:blue">供货</span>
                    <span v-else-if="data.sales_model == 2" style="color:darkgreen">直销</span>
                    <span v-else>--</span>
                  </template>
                </c-table-column>

                <c-table-column
                    label="可售范围"
                    width="80"
                    name="visible_user_level_name"
                    v-if="systemConfig.share_enable == 'ON'"
                >
                  <template #default="{data}">
                    <span v-if="data.visible_user_level_name && data.visible_user_level_name == '全部用户'" style="color:blue">全部用户</span>
                    <span v-else v-for="(item, i) in data.visible_user_level_name.split(',')" :key="i" style="color:darkslategrey;display: block;">{{item}}</span>
                  </template>
                </c-table-column>

                <c-table-column
                        label="商品售价"
                        name="product_price"
                        width="140"
                >
                    <template v-slot="{data}">
                        ￥{{data.product_price}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="分享赚奖励"
                        name="award_type"
                        width="150"
                >
                    <template v-slot="{data}">
                        <span v-if="data.award_type == 1">【固定】</span>
                        <span v-if="data.award_type == 1" style="color:blue">￥{{data.award_money}}</span>
                        <span v-if="data.award_type == 2">
                            【比例】
                        </span>
                        <span v-if="data.award_type == 2" style="color:brown">
                            {{parseFloat(data.award_ratio).toFixed(2)}} %
                        </span>
                    </template>
                </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        @sort="sortHandle"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="140"
                >
                    <template v-slot="row">
                        <c-table-button power="b_share_award_edit" @click="setProductShareAward(row)">编辑</c-table-button>
                        <c-table-button power="b_share_award_edit" @click="deleteProduct(row)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
        <c-dialog ref="editDialog" title="设置可分享会员" width="450" @resolve="submitForm">
            <c-form ref="editForm">
                <c-form-item type="checkbox" name="SHARE_AWARD_USER_LEVEL_IDS"  required :options="userLevelOptions"></c-form-item>
            </c-form>
        </c-dialog>

		<c-dialog ref="productAwardDialog" title="编辑分享赚商品" width="500" @resolve="setProductShareAwardHandle">
			<c-form ref="productAwardForm">
                <c-form-item type="input" label="商品名称" name="product_name" disabled readonly></c-form-item>
                <c-form-item v-model="shareAwardType"
                             label="分享赚奖励方式"
                             name="award_type"
                             type="radio"
                             required
                             :options="shareAwardTypeOption"
                ></c-form-item>
                <c-form-item type="number" label="奖励金额" :limit="[0.01,9999]" name="award_money" decimal="2" input-unit="元"
                             v-show="shareAwardType==1"
                             v-model="awardMoney"
                             word="推荐其他用户下单一件商品，可获得固定的奖励金额" required></c-form-item>
                <c-form-item type="number" label="奖励比例" :limit="[0.01,99]" name="award_ratio" decimal="2" input-unit="%"
                             v-show="shareAwardType==2"
                             v-model="awardRatio"
                             word="推荐其他用户下单商品时，可获得订单商品实际支付金额的部分作为奖励" required></c-form-item>
			</c-form>
		</c-dialog>
        <!--多商批量设置分享赚-->
        <c-dialog ref="batchSetShareAwardDialog" title="步骤一、设置分享赚规则" width="500" @resolve="batchSetShareAwardHandle" button-name="下一步">
            <c-form ref="batchSetShareAwardForm">
                <c-form-item v-model="shareAwardType"
                             label="分享赚奖励方式"
                             name="award_type"
                             type="radio"
                             required
                             :options="shareAwardTypeOption"
                ></c-form-item>
                <c-form-item type="number" label="奖励金额" :limit="[0.01,9999]" name="award_money" decimal="2" input-unit="元"
                             v-show="shareAwardType==1"
                             v-model="awardMoney"
                             word="推荐其他用户下单一件商品，可获得固定的奖励金额" required></c-form-item>
                <c-form-item type="number" label="奖励比例" :limit="[0.01,99]" name="award_ratio" decimal="2" input-unit="%"
                             v-show="shareAwardType==2"
                             v-model="awardRatio"
                             word="推荐其他用户下单商品时，可获得订单商品实际支付金额的部分作为奖励" required></c-form-item>
            </c-form>
        </c-dialog>

		<c-dialog ref="addDialog" title="步骤三、确认商品奖励数据" width="900" @resolve="addProductHandle" button-name="提交数据">
			<m-operate>
				<c-button color="sys" @click="$refs.productSelector.open()">添加商品</c-button>
			</m-operate>
			
			<c-table ref="addTable" v-model="addList" height="450" :paging="false">
                <c-table-column
                        label="商品状态"
                        name="state"
                        width="50"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 0" style="color:red">{{productStateName[data.state]}}</span>
                        <span v-if="data.state == 1" style="color:#999999">{{productStateName[data.state]}}</span>
                        <span v-if="data.state == 2" style="color:green">{{productStateName[data.state]}}</span>
                        <span v-if="data.state == 3" style="color:blue">{{productStateName[data.state]}}</span>
                        <span v-if="data.state == 4" style="color:red">{{productStateName[data.state]}}</span>
                    </template>
                </c-table-column>

				<c-table-column
					label="商品信息"
					width="200"
				>
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                    </template>
				</c-table-column>

				<c-table-column
					label="商品售价"
					name="product_price"
					width="80"
				>
                    <template v-slot="{data}">
                        ￥{{data.product_price}}
                    </template>
                </c-table-column>

                <c-table-column
					:label="shareAwardType==1 ? '奖励金额' : '奖励比例(%)'"
                    width="80"
                >
					<template v-slot="row">
						<c-input v-if="shareAwardType==1" v-model="row.data.award_money" type="number" :limit="[0.01,9999]" name="award_money" decimal="2" input-unit="元"></c-input>
						<c-input v-else v-model="row.data.award_ratio" type="number" :limit="[0.01,99]" name="award_ratio" decimal="2" input-unit="%"></c-input>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="80"
				>
					<template v-slot="row">
						<c-table-button @click="row.remove()">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>

		<product-selector ref="productSelector" multiple @resolve="productSelectHandle" buttonName="下一步" titleName="步骤二:批量选择商品"></product-selector>
	</page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	import productSelector from '@/components/service/product_selector.vue'
    import {mapState} from "vuex";

	export default {
		name: 'm_points_product',
		
		components: {
			productInfo, productSelector
		},

        computed: {
            ...mapState(['systemConfig','dict']),
            ...mapState({
                productStateName: state => state.dict.productState
            })
        },
		
		data() {
			return {
            exchangeType:'',
            addList: [],
            couponList:[],
            productState: [
                {name: '草稿',value: 0},
                {name: '上架',value: 2},
                {name: '下架',value: 1},
                {name: '待审核',value: 3},
                {name: '已驳回',value: 4}
            ],
            shareAwardTypeOption: [
                {name: '奖励固定金额', value: 1},
                {name: '按金额比例奖励', value: 2}
            ],
            shareAwardType:1,        //分享赚奖励方式
            awardMoney:'',        //分享赚奖励金额
            awardRatio:'',        //分享赚奖励比例，小数存储，0.1表示奖励
            searchSalesModelOptions: [
              {name: '供货', value: 1},
              {name: '直销', value: 2}
            ],
            userLevelOptions:[]
			}
		},
		
		mounted() {
			this.$refs.search.search();
            this.initUserLevel();
		},
        watch: {
        },

		methods: {

			searchHandle(data) {
                this.$refs.table.load({
                    url: '/product_share_award/list',
                    data
                });
			},
            //数据排序
            sortHandle(row, type, next) {
                this.request({
                    url: '/product_share_award/sort',
                    data: {
                        id: row.data.id,
                        parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
                        type: ['top', 'bottom'].includes(type) ? type : '',
                        id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
                        id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
                    },
                    loading: true,
                    success: data => {
                        next();
                    }
                });
            },

            /***初始化用户等级**/
            initUserLevel() {
                this.request({
                    url: '/user_level/options',
                    data: {},
                    loading: true,
                    success: data => {
                        this.userLevelOptions = data;
                    }
                });
            },
            //批量设置商品分享赚数据
            batchSetProductShareAward(){
                this.addList = [];
                this.$refs.batchSetShareAwardForm.clear();
                this.$refs.batchSetShareAwardForm.set({
                    "is_share_award":1,
                    "award_type":1
                });
                this.$refs.batchSetShareAwardDialog.open();
            },
            /*
            批量设置商品分享赚数据-提交数据
            */
            batchSetShareAwardHandle(stop){
                stop();
                if (this.shareAwardType == 1 && !this.awardMoney){
                    this.$message({
                        text: '请填写分享赚奖励金额',
                        icon: 'fail'
                    });
                    return false;
                }
                if (this.shareAwardType == 2 && !this.awardRatio){
                    this.$message({
                        text: '请填写分享赚奖励比例',
                        icon: 'fail'
                    });
                    return false;
                }
                this.$refs.batchSetShareAwardDialog.close();
                this.$refs.productSelector.open();
            },

			setProductShareAward(item) {
				this._edit = item;
				this.$refs.productAwardForm.set(item.data);
				this.$refs.productAwardDialog.open();
			},
			
			setProductShareAwardHandle(stop) {
				stop();
				this.$refs.productAwardForm.submit({
					url: '/product_share_award/edit',
					rule: {
                        award_type: '请选择分享赚奖励方式',
                        award_money: [{
                            type: 'empty',
                            skip: () => {
                                return this.shareAwardType == 2;
                            },
                            word: '请填写分享赚商品奖励金额'
                        }],
                        award_ratio: [{
                            type: 'empty',
                            skip: () => {
                                return this.shareAwardType == 1;
                            },
                            word: '请填写分享赚商品奖励比例'
                        }],
					},
					
					dataFormatter: data => {
						data.id = this._edit.data.id;
						return data;
					},
					
					success: data => {
						this.$refs.productAwardDialog.close();
						this.$message({
							text: '编辑成功'
						});
                        this.$refs.table.update();
                    }
				})
			},
			
			deleteProduct(item) {
				this.$confirm({
					text: '确定要删除此商品吗？',
					resolve: () => {
						this.request({
							url: '/product_share_award/delete',
							data: {
								id: item.data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
                                this.$refs.table.update();
                            }
						});
					}
				});
			},

			productSelectHandle(list) {
				list = list.filter(item => {
					return !this.addList.find(row => {
						return row.product_id == item.product_id;
					});
				});
                list = list.map(item => {
                    if (this.shareAwardType == 1 && this.awardMoney){
                        item.award_money = this.awardMoney;
                    }else if (this.shareAwardType == 2 && this.awardRatio){
                        item.award_ratio = this.awardRatio;
                    }
                    return item;
                });
				this.addList = this.addList.concat(list);
				this.$refs.addDialog.open();
			},
			
			addProductHandle(stop) {
				stop();
				
				if (!this.addList.length) {
					this.$message({
						text: '请选择需要添加的分享赚商品'
					});
					return;
				}
                for (let i in this.addList) {
                    var obj = this.addList[i];
                    if (this.shareAwardType == 1 && !obj.award_money) {
                        this.$message({
                            text: '请填写分享赚商品奖励金额'
                        });
                        return false;
                    }
                    if (this.shareAwardType == 2 && !obj.award_ratio) {
                        this.$message({
                            text: '请填写分享赚商品奖励比例'
                        });
                        return false;
                    }
                }
				this.request({
					url: '/product_share_award/add',
					data: {
                        award_type:this.shareAwardType,
						list: Array.from(this.addList, (item) => {
							return {
								product_id: item.product_id,
                                award_money: item.award_money,
                                award_ratio: item.award_ratio
							}
						})
					},
					loading: true,
					success: () => {
						this.$refs.addDialog.close();
						this.$refs.table.update(1);
					}
				})
			},

            otherConfig(){
                this.request({
                    url: '/product_share_award/config',
                    loading: true,
                    success: (data) => {
                        this.$refs.editForm.clear();
                        this.$refs.editForm.set(data);
                        this.$refs.editDialog.open();
                    }
                });

            },

            submitForm(stop) {
                stop();
                let submitUrl = '/product_share_award/config/update';
                this.$refs.editForm.submit({
                    url: submitUrl,
                    rule: {
                        SHARE_AWARD_USER_LEVEL_IDS: [{
                            type: 'empty',
                            word: '请至少选择一个用户等级'
                        }]
                    },
                    dataFormatter: data => {
                        let platform_config_list = [];
                        let obj={};
                        obj.config_item_code="SHARE_AWARD_USER_LEVEL_IDS";
                        obj.config_item_value= data.SHARE_AWARD_USER_LEVEL_IDS.join(",");
                        platform_config_list.push(obj);
                        data.platform_config_list = platform_config_list;
                        return data;
                    },
                    success:(data,res) => {
                        this.$message({
                            text: '操作成功',
                            icon: 'success'
                        });
                        this.$refs.editDialog.close();
                    },
                });
            }
		}
	}
</script>